import {CardContent, CardHeader, Stack} from "@mui/material";
import {Checkbox, EditForm, TextField} from "@variocube/app-ui";
import React, {useEffect, useState} from "react";
import {Compartment, CompartmentMutation} from "../../api";
import {useLocalization, useWordingFlavor} from "@smalox/shared";

interface CompartmentEditFormProps {
	loading: boolean;
	compartment?: Compartment;
	onSave: (mutation: CompartmentMutation) => Promise<any>;
}

export function CompartmentEditForm(props: Readonly<CompartmentEditFormProps>) {
	const {loading, compartment, onSave} = props;
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();

	const [number, setNumber] = useState("");
	const [size, setSize] = useState("");
	const [enabled, setEnabled] = useState<boolean>(true);

	useEffect(() => {
		if (compartment) {
			setNumber(compartment.number?.slice(0, 16));
			setSize(compartment.size ?? "");
			setEnabled(compartment.enabled);
		}
	}, [compartment]);

	async function handleSave() {
		await onSave({
			number,
			size,
			enabled,
		});
	}

	return (
		<EditForm loading={loading} onSave={handleSave} labels={t}>
			<CardHeader title={t(`compartments.settings.${wordingFlavor}`)} />
			<CardContent>
				<Stack spacing={2}>
					<TextField
						label={t("compartments.number")}
						value={number}
						onChange={setNumber}
						fullWidth
						required
						inputProps={{
							maxLength: 16,
						}}
						helperText={t("compartments.maxLengthNumber")}
					/>
					<TextField
						label={t("compartments.size")}
						value={size}
						onChange={setSize}
						fullWidth
					/>
					<Checkbox
						label={t("compartments.enabled")}
						value={enabled}
						onChange={setEnabled}
					/>
				</Stack>
			</CardContent>
		</EditForm>
	);
}
